import React from 'react';
import { CollectionEntity, CollectionEntities } from './model';
import { SelectableEggCardCollection } from '../SelectableCard/Variants/SelectableCardEgg';
import { SelectableCardProps } from '../SelectableCard/SelectableCard';
import { SelectableCardBreaker } from '../SelectableCard/Variants/SelectableCardBreaker';
import { SelectableCardGribble } from '../SelectableCard/Variants/SelectableCardGribble';
import { useCollectionContext } from './context';
import styles from './CollectionGrid.module.scss';
import { SelectableCardPlaceholder } from '../SelectableCard/Variants/SelectableCardPlaceholder';
import { useCollection } from './fetcher';

export function DynamicCollectionComponent(
  props: {
    entity: CollectionEntity;
  } & Omit<SelectableCardProps<any>, 'card'>,
) {
  const { entity, ...rest } = props;
  switch (entity.type) {
    case CollectionEntities.Duskbreakers:
      return (
        <SelectableCardBreaker {...rest} card={SelectableCardBreaker.transformer(entity.item)} />
      );
    case CollectionEntities.Eggs:
      return (
        <SelectableEggCardCollection
          {...rest}
          card={SelectableEggCardCollection.transformer(entity.item)}
        />
      );
    case CollectionEntities.Gribbles:
      return (
        <SelectableCardGribble {...rest} card={SelectableCardGribble.transformer(entity.item)} />
      );
  }
}

const placeholders = Array.from({ length: 30 }, (_, i) => {
  return <SelectableCardPlaceholder key={i} />;
});

export function CollectionGrid() {
  const { filter } = useCollectionContext();
  // Acceptable to re-use the hook here since the results are cached
  // and there is no extra network request made
  const { data, isLoading, isFetchingNextPage } = useCollection(filter.type);
  const { selected, setSelected } = useCollectionContext();
  const items = data?.pages.flatMap((page) => page.items);

  return (
    <div>
      <div className={styles.grid}>
        {selected &&
          items?.map((entity) => (
            <DynamicCollectionComponent
              role="button"
              onClick={() => setSelected(entity)}
              key={`${entity.type}-${entity.item.id}`}
              className={styles.gridItem}
              entity={entity}
              isSelected={selected.item.id === entity.item.id}
            />
          ))}
        {(isLoading || isFetchingNextPage) && placeholders}
      </div>
    </div>
  );
}
